import { useQuery } from '@tanstack/react-query';
import { useApi } from 'common/hooks/api';
import Agency from 'models/Agency';

const CACHE_KEYS = {
  ACCOMMODATIONS: 'accommodations',
  MEDIA_CONTENT: 'mediaContent',
  FEATURED: 'carousel',
  SERVICE: 'services',
  COUNTRIES: 'countries',
  REGIONS: 'regions',
};
export const mediaContentKey = mediaContentId => ['mediaContent', mediaContentId];

export const useMediaContentQuery = ({ mediaContentId }) => {
  const Api = useApi();
  const query = useQuery({
    queryKey: mediaContentKey(mediaContentId),
    queryFn: async () => {
      const response = await Api.getAgency(mediaContentId);
      return new Agency(response?.data);
    },
    retry: (_failureCount, error) => {
      if (error?.response?.status === 404) return false;
      return true;
    },
    cacheTime: 0,
  });
  return query;
};

export const useMediaContentForCountry = countryCode => {
  const Api = useApi();
  const query = useQuery({
    queryKey: [CACHE_KEYS.MEDIA_CONTENT, CACHE_KEYS.FEATURED, CACHE_KEYS.COUNTRIES, countryCode],
    queryFn: async () => {
      const response = await Api.getCountryInfo(countryCode);
      const data = [];
      response.data.countryCoverMedia && data.push(response.data.countryCoverMedia);
      response.data.countryFeaturedMedia && data.push(response.data.countryFeaturedMedia);
      response.data.countryCarouselMedia && data.concat(response.data.countryCarouselMedia);
      return data;
    },
    enabled: !!countryCode,
  });
  return query;
};
export const useMediaContentForRegion = id => {
  const Api = useApi();
  const query = useQuery({
    queryKey: [CACHE_KEYS.MEDIA_CONTENT, CACHE_KEYS.FEATURED, CACHE_KEYS.REGIONS, id],
    queryFn: async () => {
      const response = await Api.getRegionInfo(id);
      const media = [];
      const { regionCoverMedia, regionFeaturedMedia, regionCarouselMedia } = response.data;
      regionCoverMedia && media.push(regionCoverMedia);
      regionFeaturedMedia && media.push(regionFeaturedMedia);
      regionCarouselMedia && regionCarouselMedia.length && media.concat(regionCarouselMedia);
      return media;
    },
    enabled: !!id,
  });
  return query;
};
